import { Button, DatePicker, Table, Tag, Row, Col, message } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { selectBaseUrl, selectProdTestUrl } from "../../../redux/slices/envSlice";
import { get_tat_failure_report } from "../../../endpoints/API";

const TatFailureReport = () => {
  const { RangePicker } = DatePicker;
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [data, setData] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);

  React.useEffect(() => {
    fetchReportData(selectedDates);
  }, []);

  const fetchReportData = async (dates) => {
    try {
      const response = await get_tat_failure_report(dates?.[0], dates?.[1]);
      if (response.status !== 200) throw new Error("Request failed");
      const result = response?.data;
      setData(result.data || []);
    } catch (error) {
      message.error(error?.response?.data?.error || "Error fetching report data");
    }
  };

  const handleDateChange = (value, dateString) => {
    setSelectedDates(dateString);
    fetchReportData(dateString);
  };

  const columns = [
    { title: "Order Number", dataIndex: "order_number", key: "order_number", width: 120, fixed: "left" },
    { title: "Test Name", dataIndex: "test_name", key: "test_name", width: 140, render: (text) => text || "-" },
    { title: "Order Created", dataIndex: "order_created", key: "order_created", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Customer Name", dataIndex: "customer_name", key: "customer_name", width: 130, render: (text) => text || "-" },
    { title: "Wellness Executive", dataIndex: "wellness_executive_name", key: "wellness_executive_name", width: 145, render: (text) => text || "-" },
    { title: "Order Accept", dataIndex: "order_accept", key: "order_accept", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Arriving At Location", dataIndex: "arriving_at_location", key: "arriving_at_location", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    // { title: "Order Completion Time", dataIndex: "order_completion", key: "order_completion", render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Lab Reaching Time", dataIndex: "lab_reaching", key: "lab_reaching", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Report Generate Time", dataIndex: "report_generated", key: "report_generated", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "TAT Minutes", dataIndex: "tat_minutes", key: "tat_minutes", width: 110 },
    { title: "TAT Failed Time", dataIndex: "tat_failed_time", key: "tat_failed_time", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
  ];

  return (
    <div style={{ padding: "10px", margin: "10px" }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 12 }}>
        <Col xs={24} sm={6}>
          <div style={{ fontWeight: 600 }}>
            Total: <Tag>{data?.length}</Tag>
          </div>
        </Col>
        <Col xs={24} sm={18} style={{ display: "flex", justifyContent: "flex-end" }}>
          <RangePicker
            format="YYYY-MM-DD"
            onChange={handleDateChange}
            disabledDate={(current) => current && current > dayjs().endOf("day")}
            style={{ width: "100%", maxWidth: 420 }}
            size="large"
            getPopupContainer={(trigger) => document.body}
            dropdownClassName="custom-range-picker-dropdown"
          />
        </Col>
      </Row>

      <div style={{ overflowX: "auto", width: "100%" }}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey={(record, index) => index}
          scroll={{ x: "max-content" }}
          size="small"
          pagination={{ pageSize: 10, responsive: true }}
        />
      </div>

      <style>{`
        @media (max-width: 768px) {
          .custom-range-picker-dropdown .ant-picker-panels {
            flex-direction: column !important;
          }
          .custom-range-picker-dropdown {
            max-width: 95vw !important;
            overflow-x: auto !important;
          }
          .ant-table { font-size: 12px !important; }
          .ant-table-cell { padding: 6px 8px !important; white-space: nowrap; }
          .ant-tag { font-size: 11px !important; }
        }
      `}</style>
    </div>
  );
};

export default TatFailureReport;